import React from 'react'
import classnames from 'classnames'

import InternalLink from '../../../components/InternalLink'

import useStyles from './styles'

function SettingsNavMenu({ ...props }) {
  const { settings, subPagePath, closeMenu, sectionName } = props

  const classes = useStyles()

  function isSelectedSetting(path) {
    return path === subPagePath
  }

  const isActiveItem = path => {
    return isSelectedSetting(path) ? 'selected' : ''
  }

  return (
    <nav className={classes.nav}>
      <div className={classes.sectionName}>{sectionName}</div>
      {settings.map(({ path, pathParam, title }) => (
        <div key={path} className={classes.navItem}>
          <InternalLink onClick={closeMenu} to={path} className={classnames(classes.navLink, isActiveItem(pathParam))}>
            {title}
          </InternalLink>
        </div>
      ))}
    </nav>
  )
}

export default SettingsNavMenu
